export default __webpack_public_path__ + "static/media/10w40.a6cfa636.png";